// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.panel-content {
  margin-top: 0;
}

.button-group-centered {
  display: flex;
  margin: 20px 0;
  margin-top: 2%;
}

.booking-details-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 25px;
  padding: 10px;
  font-size: 13px;
}

.booking-details-grid div {
  font-weight: normal;
}

.booking-details-grid strong {
  font-weight: bold;
  color: #000;
}

.journey-log-table {
  width: 100%;
  margin-top: 16px;
  font-size: 14px;
  border: 1.7px solid #ddd;
}
.journey-log-table th, .journey-log-table td {
  border: 1px solid #ddd;
  color: #000;
  padding: 8px;
  text-align: left;
}
.journey-log-table th {
  font-size: 0.8rem;
  font-weight: bold;
  background-color: #e5f0f7;
}

.journey-log-header {
  font-size: 1rem;
  color: #000;
  margin-top: 0;
}

.tab-container {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 10px 0;
}

.tab-container .active-tab {
  font-weight: bold;
}

.McTab {
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.McTab:hover {
  background-color: #eaeaea;
}

.active-tab {
  background-color: #f5f5f5;
}

.loading-center {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 250px;
  font-size: 16px;
  color: #666;
}

.ellipsis-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 120px;
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/Components/Panel/Panel.scss"],"names":[],"mappings":"AACA;EACI,aAAA;AAAJ;;AAGA;EACI,aAAA;EACA,cAAA;EACA,cAAA;AAAJ;;AAEA;EACI,aAAA;EACA,qCAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;AACJ;;AACA;EACI,mBAAA;AAEJ;;AAAA;EACI,iBAAA;EACA,WAAA;AAGJ;;AADA;EACI,WAAA;EAEA,gBAAA;EACA,eAAA;EACA,wBAAA;AAGJ;AADI;EACI,sBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AAGR;AAAI;EACI,iBAAA;EACA,iBAAA;EACA,yBAAA;AAER;;AAEA;EACI,eAAA;EACA,WAAA;EACA,aAAA;AACJ;;AACA;EACI,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,eAAA;AAEJ;;AAEA;EACI,iBAAA;AACJ;;AACA;EACI,eAAA;EACA,sCAAA;AAEJ;;AAAA;EACI,yBAAA;AAGJ;;AADA;EACI,yBAAA;AAIJ;;AADA;EACG,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;AAIH;;AAFA;EACI,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;EACA,eAAA;AAKJ","sourcesContent":["\n.panel-content {\n    margin-top: 0;\n}\n\n.button-group-centered {\n    display: flex;\n    margin: 20px 0;\n    margin-top: 2%;\n}\n.booking-details-grid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr); \n    gap: 25px;\n    padding: 10px;\n    font-size: 13px;\n}\n.booking-details-grid div {\n    font-weight: normal;\n}\n.booking-details-grid strong {\n    font-weight: bold;\n    color: #000;\n}\n.journey-log-table {\n    width: 100%;\n    // border-collapse: collapse;\n    margin-top: 16px;\n    font-size: 14px;\n    border: 1.7px solid #ddd;\n\n    th, td {\n        border: 1px solid #ddd;\n        color: #000;\n        padding: 8px;\n        text-align: left;\n    }\n\n    th {\n        font-size: 0.8rem;\n        font-weight: bold;\n        background-color: #e5f0f7;\n    }\n}\n\n.journey-log-header{\n    font-size: 1rem;\n    color: #000;\n    margin-top: 0;\n}\n.tab-container {\n    display: flex;\n    justify-content: space-around; \n    align-items: center; \n    padding: 10px 0; \n}\n\n\n.tab-container .active-tab {\n    font-weight: bold; \n}\n.McTab{\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n}\n.McTab:hover{\n    background-color: #eaeaea;\n}\n.active-tab{\n    background-color: #f5f5f5;\n\n}\n.loading-center{\n   display: flex;\n   justify-content: center;\n   align-items: center;\n   height: 250px;\n   font-size: 16px;\n   color: #666;\n}\n.ellipsis-text{\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 120px;\n    display: inline-block;\n    vertical-align: middle;\n    cursor: pointer;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
